import React from 'react';
import { ProfitMaximizerUpsell } from '../components/ProfitMaximizerUpsell';
export function Modulo4Page() {
  return <div className="min-h-screen bg-[#0a0a0a] text-[#e0e0e0] font-body" data-id="element-2026">
      {/* TOP NAV */}
      <nav className="sticky top-0 z-[100] flex h-[56px] items-center justify-between border-b border-[#1a1a1a] bg-black px-4 md:px-10" data-id="element-2027">
        <div className="font-heading text-[13px] font-black tracking-[3px] text-white uppercase" data-id="element-2028">
          AI <span className="text-[#F5C842]" data-id="element-2029">WEB CLOSER</span>
        </div>
        <div className="flex gap-1 overflow-x-auto" data-id="element-2030">
          <a href="/modulo-0" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#555] transition-all hover:bg-[#1a1a1a] hover:text-white" data-id="element-2031">
            Módulo 0
          </a>
          <a href="/modulo-1" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#555] transition-all hover:bg-[#1a1a1a] hover:text-white" data-id="element-2032">
            Módulo 1
          </a>
          <a href="/modulo-2" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#555] transition-all hover:bg-[#1a1a1a] hover:text-white" data-id="element-2033">
            Módulo 2
          </a>
          <a href="/modulo-3" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#555] transition-all hover:bg-[#1a1a1a] hover:text-white" data-id="element-2034">
            Módulo 3
          </a>
          <a href="/modulo-4" className="rounded bg-[#F5C842] px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-black transition-all" data-id="element-2035">
            Módulo 4
          </a>
          <a href="/calculadora" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#F5C842] transition-all hover:bg-[#1a1a1a] border border-[#F5C842]/30" data-id="element-2036">
            Calculadora
          </a>
        </div>
      </nav>

      {/* HERO */}
      <div className="border-b-[3px] border-[#F5C842] bg-gradient-to-br from-black to-[#0d0d0d] px-6 py-10 md:px-20 md:py-[60px] md:pb-[50px]" data-id="element-2037">
        <div className="mb-5 flex items-center gap-2.5" data-id="element-2038">
          <div className="rounded-sm bg-[#F5C842] px-3.5 py-1 font-heading text-[9px] font-black tracking-[3px] text-black uppercase" data-id="element-2039">
            Módulo 4 de 4 — Final
          </div>
          <div className="text-[11px] tracking-[2px] text-[#444] uppercase" data-id="element-2040">
            ⏱ 15 minutos · El Guion de Cierre Completo
          </div>
        </div>
        <div className="mb-4 font-heading text-4xl md:text-[48px] font-black leading-[1.05] text-white" data-id="element-2041">
          El Cierre
          <br data-id="element-2042" />
          <span className="text-[#F5C842]" data-id="element-2043">Sin Presión</span>
        </div>
        <div className="mb-8 max-w-[600px] text-[15px] leading-[1.7] text-[#888]" data-id="element-2044">
          El guion exacto para convertir una conversación casual en una venta de
          $350. No es una venta — es una conversación. Y tienes algo que ellos
          quieren.
        </div>
        <div className="flex flex-col md:flex-row gap-4 md:gap-6" data-id="element-2045">
          <div className="flex items-center gap-2 text-[12px] text-[#555]" data-id="element-2046">
            <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-2047"></div>
            Guion de apertura + seguimiento
          </div>
          <div className="flex items-center gap-2 text-[12px] text-[#555]" data-id="element-2048">
            <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-2049"></div>
            Las 5 objeciones y cómo responderlas
          </div>
          <div className="flex items-center gap-2 text-[12px] text-[#555]" data-id="element-2050">
            <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-2051"></div>
            Estrategia de precios y plan de pagos
          </div>
        </div>
      </div>

      {/* MAIN */}
      <div className="mx-auto max-w-[1100px] px-4 py-10 md:px-10 md:py-[50px]" data-id="element-2052">
        {/* MINDSET BANNER */}
        <div className="mb-8 rounded-r-lg border border-[#2a2a2a] border-l-[4px] border-l-[#F5C842] bg-gradient-to-br from-[#0d0d0d] to-[#111] px-7 py-6" data-id="element-2053">
          <div className="mb-2 font-heading text-[16px] font-black text-[#F5C842]" data-id="element-2054">
            &#x1F4A1; El Cambio de Mentalidad que lo Cambia Todo
          </div>
          <div className="text-[13px] leading-[1.75] text-[#bbb]" data-id="element-2055">
            Sé que para muchos esta es la parte más intimidante. Llamar a un
            extraño y ofrecerle algo. Pero cuando termines este módulo, vas a
            ver que{' '}
            <strong className="text-white" data-id="element-2056">
              no es una venta. Es una conversación.
            </strong>{' '}
            Y tienes algo que ellos quieren — su negocio representado de forma
            profesional en internet.
          </div>
        </div>

        {/* SCRIPT CARDS */}
        <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-2057">
          <span className="inline-block h-[2px] w-5 bg-[#F5C842]" data-id="element-2058"></span>
          El Guion de Cierre — Copiar y Pegar
        </div>

        {/* PASO 1 */}
        <div className="mb-5 overflow-hidden rounded-[10px] border border-[#2a2a2a] bg-black" data-id="element-2059">
          <div className="flex items-center gap-2.5 border-b border-[#1e1e1e] bg-[#111] px-[22px] py-3.5" data-id="element-2060">
            <span className="text-[18px]" data-id="element-2061">📱</span>
            <span className="font-heading text-[13px] font-black text-white" data-id="element-2062">
              PASO 1 — Apertura (WhatsApp o llamada)
            </span>
            <span className="ml-auto text-[10px] text-[#555]" data-id="element-2063">
              ⏱ Primer contacto
            </span>
          </div>
          <div className="whitespace-pre-wrap px-[22px] py-[22px] text-[13px] italic leading-[1.85] text-[#ccc]" data-id="element-2064">
            "Hola, ¿hablo con{' '}
            <span className="italic text-[#666]" data-id="element-2065">[Nombre del dueño]</span>? Mi
            nombre es <span className="italic text-[#666]" data-id="element-2066">[Tu nombre]</span>.
            Vi su negocio{' '}
            <span className="italic text-[#666]" data-id="element-2067">[Nombre del negocio]</span> en
            Google Maps y noté que no tienen sitio web. Tomé 10 minutos y
            preparé una demo de cómo podría verse. ¿Le puedo enviar el link para
            que lo vea?"
            <br data-id="element-2068" />
            <br data-id="element-2069" />
            <span className="not-italic font-bold text-white" data-id="element-2070">
              — Eso es todo. No vendas nada todavía. Solo pide permiso para
              enviar el link.
            </span>
            <br data-id="element-2071" />
            <span className="not-italic font-bold text-white" data-id="element-2072">
              — La mayoría dirá que sí porque es gratis y no les pides nada.
            </span>
          </div>
        </div>

        {/* PASO 2 */}
        <div className="mb-5 overflow-hidden rounded-[10px] border border-[#2a2a2a] bg-black" data-id="element-2073">
          <div className="flex items-center gap-2.5 border-b border-[#1e1e1e] bg-[#111] px-[22px] py-3.5" data-id="element-2074">
            <span className="text-[18px]" data-id="element-2075">⏳</span>
            <span className="font-heading text-[13px] font-black text-white" data-id="element-2076">
              PASO 2 — Envía la demo y espera
            </span>
            <span className="ml-auto text-[10px] text-[#555]" data-id="element-2077">
              ⏱ Inmediatamente después
            </span>
          </div>
          <div className="whitespace-pre-wrap px-[22px] py-[22px] text-[13px] italic leading-[1.85] text-[#ccc]" data-id="element-2078">
            Cuando digan que sí,{' '}
            <span className="not-italic font-bold text-[#F5C842]" data-id="element-2079">
              envía el link de la demo
            </span>{' '}
            que construiste en el Módulo 3.
            <br data-id="element-2080" />
            <br data-id="element-2081" />
            <span className="not-italic font-bold text-white" data-id="element-2082">
              Espera exactamente 10 minutos.
            </span>
            <br data-id="element-2083" />
            <br data-id="element-2084" />
            No escribas antes. No preguntes si la vieron. Espera los 10 minutos
            y luego envía el seguimiento.
          </div>
        </div>

        {/* PASO 3 */}
        <div className="mb-8 overflow-hidden rounded-[10px] border border-[#2a2a2a] bg-black" data-id="element-2085">
          <div className="flex items-center gap-2.5 border-b border-[#1e1e1e] bg-[#111] px-[22px] py-3.5" data-id="element-2086">
            <span className="text-[18px]" data-id="element-2087">💰</span>
            <span className="font-heading text-[13px] font-black text-white" data-id="element-2088">
              PASO 3 — Seguimiento y cierre
            </span>
            <span className="ml-auto text-[10px] text-[#555]" data-id="element-2089">
              ⏱ 10 minutos después de enviar la demo
            </span>
          </div>
          <div className="whitespace-pre-wrap px-[22px] py-[22px] text-[13px] italic leading-[1.85] text-[#ccc]" data-id="element-2090">
            "¿Tuvo oportunidad de verlo? ¿Qué le pareció? Puedo tenerlo listo y
            publicado en{' '}
            <span className="not-italic font-bold text-[#F5C842]" data-id="element-2091">
              48 horas por $350
            </span>
            . Incluye el dominio y el primer mes de hosting."
            <br data-id="element-2092" />
            <br data-id="element-2093" />
            <span className="not-italic font-bold text-white" data-id="element-2094">
              Si dicen que sí → cobras.
            </span>
            <br data-id="element-2095" />
            <span className="not-italic font-bold text-white" data-id="element-2096">
              Si dicen que es caro → ofrece plan de pagos: $175 ahora, $175 en
              30 días.
            </span>
            <br data-id="element-2097" />
            <span className="not-italic font-bold text-white" data-id="element-2098">
              Si siguen sin cerrar → pasa al siguiente prospecto. No negocies
              demasiado. Tu tiempo vale.
            </span>
          </div>
        </div>

        {/* PRICING */}
        <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-2099">
          <span className="inline-block h-[2px] w-5 bg-[#F5C842]" data-id="element-2100"></span>
          Estructura de Precios
        </div>
        <div className="mb-8 grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-2101">
          <div className="rounded-lg border border-[#F5C842] bg-[#0d0d0d] p-5 text-center" data-id="element-2102">
            <div className="mb-2 text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-2103">
              Precio Estándar
            </div>
            <div className="mb-1.5 font-heading text-[32px] font-black text-[#F5C842]" data-id="element-2104">
              $350
            </div>
            <div className="text-[11px] leading-[1.5] text-[#666]" data-id="element-2105">
              Sitio web completo + dominio + primer mes de hosting. Pago único
              al cerrar.
            </div>
          </div>
          <div className="rounded-lg border border-[#1e1e1e] bg-[#111] p-5 text-center" data-id="element-2106">
            <div className="mb-2 text-[9px] font-bold tracking-[2px] text-[#555] uppercase" data-id="element-2107">
              Plan de Pagos
            </div>
            <div className="mb-1.5 font-heading text-[32px] font-black text-white" data-id="element-2108">
              2x$175
            </div>
            <div className="text-[11px] leading-[1.5] text-[#666]" data-id="element-2109">
              $175 al cerrar + $175 a los 30 días. Para clientes que dicen "es
              caro".
            </div>
          </div>
          <div className="rounded-lg border border-[#1e1e1e] bg-[#111] p-5 text-center" data-id="element-2110">
            <div className="mb-2 text-[9px] font-bold tracking-[2px] text-[#555] uppercase" data-id="element-2111">
              Mantenimiento Mensual
            </div>
            <div className="mb-1.5 font-heading text-[32px] font-black text-white" data-id="element-2112">
              $99/mes
            </div>
            <div className="text-[11px] leading-[1.5] text-[#666]" data-id="element-2113">
              Hosting, actualizaciones y soporte. Ofrécelo después de entregar
              el sitio.
            </div>
          </div>
        </div>

        {/* OBJECTIONS */}
        <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-2114">
          <span className="inline-block h-[2px] w-5 bg-[#F5C842]" data-id="element-2115"></span>
          Las 5 Objeciones Más Comunes y Cómo Responderlas
        </div>
        <div className="mb-8 grid grid-cols-1 md:grid-cols-2 gap-3.5" data-id="element-2116">
          <div className="overflow-hidden rounded-lg border border-[#1e1e1e] bg-[#111]" data-id="element-2117">
            <div className="flex items-center gap-2 border-b border-[#2a1a1a] bg-[#1a0a0a] px-4 py-2.5 text-[12px] font-bold text-[#ff6b6b]" data-id="element-2118">
              ❌ "Es muy caro."
            </div>
            <div className="px-4 py-3.5 text-[12px] leading-[1.65] text-[#bbb]" data-id="element-2119">
              <span className="font-bold text-[#4caf50]" data-id="element-2120">✅ Tu respuesta:</span>{' '}
              "Entiendo. ¿Cuánto le cuesta perder un cliente porque no lo
              encontraron en Google?"
            </div>
          </div>
          <div className="overflow-hidden rounded-lg border border-[#1e1e1e] bg-[#111]" data-id="element-2121">
            <div className="flex items-center gap-2 border-b border-[#2a1a1a] bg-[#1a0a0a] px-4 py-2.5 text-[12px] font-bold text-[#ff6b6b]" data-id="element-2122">
              ❌ "Ya tengo uno."
            </div>
            <div className="px-4 py-3.5 text-[12px] leading-[1.65] text-[#bbb]" data-id="element-2123">
              <span className="font-bold text-[#4caf50]" data-id="element-2124">✅ Tu respuesta:</span>{' '}
              "¿Puedo verlo? [Pausa] Entiendo. ¿Le gustaría uno que realmente
              traiga clientes?"
            </div>
          </div>
          <div className="overflow-hidden rounded-lg border border-[#1e1e1e] bg-[#111]" data-id="element-2125">
            <div className="flex items-center gap-2 border-b border-[#2a1a1a] bg-[#1a0a0a] px-4 py-2.5 text-[12px] font-bold text-[#ff6b6b]" data-id="element-2126">
              ❌ "Déjame pensarlo."
            </div>
            <div className="px-4 py-3.5 text-[12px] leading-[1.65] text-[#bbb]" data-id="element-2127">
              <span className="font-bold text-[#4caf50]" data-id="element-2128">✅ Tu respuesta:</span>{' '}
              "Por supuesto. ¿Cuándo podría hablar con usted de nuevo? ¿Mañana a
              las 10?"
            </div>
          </div>
          <div className="overflow-hidden rounded-lg border border-[#1e1e1e] bg-[#111]" data-id="element-2129">
            <div className="flex items-center gap-2 border-b border-[#2a1a1a] bg-[#1a0a0a] px-4 py-2.5 text-[12px] font-bold text-[#ff6b6b]" data-id="element-2130">
              ❌ "No tengo tiempo."
            </div>
            <div className="px-4 py-3.5 text-[12px] leading-[1.65] text-[#bbb]" data-id="element-2131">
              <span className="font-bold text-[#4caf50]" data-id="element-2132">✅ Tu respuesta:</span>{' '}
              "No se preocupe, yo me encargo de todo. Usted solo me aprueba el
              diseño."
            </div>
          </div>
          <div className="overflow-hidden rounded-lg border border-[#1e1e1e] bg-[#111] md:col-span-2" data-id="element-2133">
            <div className="flex items-center gap-2 border-b border-[#2a1a1a] bg-[#1a0a0a] px-4 py-2.5 text-[12px] font-bold text-[#ff6b6b]" data-id="element-2134">
              ❌ "No sé si lo necesito."
            </div>
            <div className="px-4 py-3.5 text-[12px] leading-[1.65] text-[#bbb]" data-id="element-2135">
              <span className="font-bold text-[#4caf50]" data-id="element-2136">✅ Tu respuesta:</span>{' '}
              "Entiendo. ¿Sabe cuántas personas buscan{' '}
              <span className="text-[#F5C842]" data-id="element-2137">[tipo de negocio]</span> en
              Google en su ciudad cada mes? Sin sitio web, ninguna de ellas lo
              encuentra a usted."
            </div>
          </div>
        </div>

        {/* FULL SCRIPT */}
        <div className="mb-8" data-id="element-2138">
          <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-2139">
            <span className="inline-block h-[2px] w-5 bg-[#F5C842]" data-id="element-2140"></span>
            Guion Completo del Módulo
          </div>

          <div className="mb-4" data-id="element-2141">
            <div className="mb-1.5 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-2142">
              <span className="inline-block h-[2px] w-3 bg-[#F5C842]" data-id="element-2143"></span>⏱
              0:00 – 0:30 · Introducción
            </div>
            <div className="whitespace-pre-wrap rounded-r-lg border border-[#1e1e1e] border-l-[3px] border-l-[#F5C842] bg-[#0d0d0d] px-[22px] py-[18px] text-[13px] italic leading-[1.8] text-[#ccc]" data-id="element-2144">
              "Módulo 4. El cierre. Sé que para muchos esta es la parte más
              intimidante. Llamar a un extraño y ofrecerle algo. Pero te prometo
              que cuando termines este módulo, vas a ver que no es una venta. Es
              una conversación. Y tienes algo que ellos quieren."
            </div>
          </div>

          <div className="mb-4" data-id="element-2145">
            <div className="mb-1.5 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-2146">
              <span className="inline-block h-[2px] w-3 bg-[#F5C842]" data-id="element-2147"></span>⏱
              0:30 – 10:00 · El Guion de Cierre
            </div>
            <div className="whitespace-pre-wrap rounded-r-lg border border-[#1e1e1e] border-l-[3px] border-l-[#F5C842] bg-[#0d0d0d] px-[22px] py-[18px] text-[13px] italic leading-[1.8] text-[#ccc]" data-id="element-2148">
              "Voy a darte el guion exacto. Puedes leerlo las primeras veces si
              necesitas. Con el tiempo, será natural."
              <br data-id="element-2149" />
              <br data-id="element-2150" />
              <span className="not-italic font-bold text-[#F5C842]" data-id="element-2151">
                APERTURA (WhatsApp o llamada):
              </span>
              <br data-id="element-2152" />
              "'Hola, ¿hablo con{' '}
              <span className="italic text-[#666]" data-id="element-2153">[Nombre del dueño]</span>? Mi
              nombre es <span className="italic text-[#666]" data-id="element-2154">[Tu nombre]</span>.
              Vi su negocio{' '}
              <span className="italic text-[#666]" data-id="element-2155">[Nombre del negocio]</span>{' '}
              en Google Maps y noté que no tienen sitio web. Tomé 10 minutos y
              preparé una demo de cómo podría verse. ¿Le puedo enviar el link
              para que lo vea?'"
              <br data-id="element-2156" />
              <br data-id="element-2157" />
              "Eso es todo. No vendas nada todavía. Solo pide permiso para
              enviar el link."
              <br data-id="element-2158" />
              <br data-id="element-2159" />
              "Cuando digan que sí (y la mayoría dirá que sí porque es gratis y
              no les pides nada), envía el link de la demo y espera 10 minutos.
              Luego escribe:"
              <br data-id="element-2160" />
              <br data-id="element-2161" />
              <span className="not-italic font-bold text-[#F5C842]" data-id="element-2162">
                SEGUIMIENTO:
              </span>
              <br data-id="element-2163" />
              "'¿Tuvo oportunidad de verlo? ¿Qué le pareció? Puedo tenerlo listo
              y publicado en 48 horas por $350. Incluye el dominio y el primer
              mes de hosting.'"
              <br data-id="element-2164" />
              <br data-id="element-2165" />
              "Si dicen que sí, cobras. Si dicen que es caro, tienes dos
              opciones: ofrecer un plan de pagos ($175 ahora, $175 en 30 días) o
              simplemente pasar al siguiente prospecto. No negocies demasiado.
              Tu tiempo vale."
            </div>
          </div>

          <div className="mb-4" data-id="element-2166">
            <div className="mb-1.5 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-2167">
              <span className="inline-block h-[2px] w-3 bg-[#F5C842]" data-id="element-2168"></span>⏱
              10:00 – 13:00 · Las 5 Objeciones
            </div>
            <div className="whitespace-pre-wrap rounded-r-lg border border-[#1e1e1e] border-l-[3px] border-l-[#F5C842] bg-[#0d0d0d] px-[22px] py-[18px] text-[13px] italic leading-[1.8] text-[#ccc]" data-id="element-2169">
              "Las 5 objeciones más comunes y cómo responderlas:"
              <br data-id="element-2170" />
              <br data-id="element-2171" />
              "1. 'Es muy caro.' → 'Entiendo. ¿Cuánto le cuesta perder un
              cliente porque no lo encontraron en Google?'"
              <br data-id="element-2172" />
              "2. 'Ya tengo uno.' → '¿Puedo verlo? [Pausa] Entiendo. ¿Le
              gustaría uno que realmente traiga clientes?'"
              <br data-id="element-2173" />
              "3. 'Déjame pensarlo.' → 'Por supuesto. ¿Cuándo podría hablar con
              usted de nuevo? ¿Mañana a las 10?'"
              <br data-id="element-2174" />
              "4. 'No tengo tiempo.' → 'No se preocupe, yo me encargo de todo.
              Usted solo me aprueba el diseño.'"
              <br data-id="element-2175" />
              "5. 'No sé si lo necesito.' → 'Entiendo. ¿Sabe cuántas personas
              buscan [tipo de negocio] en Google en su ciudad cada mes? Sin
              sitio web, ninguna de ellas lo encuentra a usted.'"
            </div>
          </div>

          <div className="mb-4" data-id="element-2176">
            <div className="mb-1.5 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-2177">
              <span className="inline-block h-[2px] w-3 bg-[#F5C842]" data-id="element-2178"></span>⏱
              13:00 – 15:00 · Cierre Final del Curso
            </div>
            <div className="whitespace-pre-wrap rounded-r-lg border border-[#1e1e1e] border-l-[3px] border-l-[#F5C842] bg-[#0d0d0d] px-[22px] py-[18px] text-[13px] italic leading-[1.8] text-[#ccc]" data-id="element-2179">
              "Eso es todo. Tienes el sistema completo. Ahora ve y contacta tus
              5 prospectos hoy. No mañana. Hoy. El dinero está ahí afuera
              esperándote. El único paso que falta eres tú."
            </div>
          </div>
        </div>

        {/* TASK */}
        <div className="mb-8 rounded-r-lg border border-[#1a3a1a] border-l-[4px] border-l-[#4caf50] bg-[#0a150a] px-[26px] py-[22px]" data-id="element-2180">
          <div className="mb-2.5 font-heading text-[9px] font-bold tracking-[2px] text-[#4caf50] uppercase" data-id="element-2181">
            ✅ Tu Tarea Final — Módulo 4
          </div>
          <div className="text-[13px] leading-[1.75] text-[#bbb]" data-id="element-2182">
            Contacta a tus{' '}
            <strong className="text-white" data-id="element-2183">5 prospectos hoy</strong>. No mañana.
            Hoy. Tu objetivo es cerrar al menos 1 venta esta semana.
            <div className="mt-3 flex flex-col gap-2" data-id="element-2184">
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-2185">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-2186">
                  1
                </div>
                Envía el mensaje de apertura al Prospecto #1 (WhatsApp o
                llamada)
              </div>
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-2187">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-2188">
                  2
                </div>
                Cuando diga que sí, envía el link de su demo
              </div>
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-2189">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-2190">
                  3
                </div>
                Espera 10 minutos y envía el seguimiento con el precio de $350
              </div>
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-2191">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-2192">
                  4
                </div>
                Repite con los 5 prospectos de tu lista
              </div>
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-2193">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-2194">
                  5
                </div>
                <strong className="text-white" data-id="element-2195">
                  Objetivo: cerrar al menos 1 venta esta semana
                </strong>
              </div>
            </div>
          </div>
        </div>

        {/* CLOSING BANNER */}
        <div className="mb-8 rounded-lg border border-[#2a2a2a] border-t-[3px] border-t-[#F5C842] bg-black px-10 py-10 text-center" data-id="element-2196">
          <div className="mb-3 font-heading text-[28px] font-black leading-tight text-white" data-id="element-2197">
            Ahora Ve y<br data-id="element-2198" />
            <span className="text-[#F5C842]" data-id="element-2199">Cierra Tu Primer Cliente</span>
          </div>
          <div className="mx-auto max-w-[500px] text-[14px] leading-[1.7] text-[#777]" data-id="element-2200">
            Tienes el sistema completo. Los cerebros de IA. El guion. Las demos.
            El único paso que falta eres tú. El dinero está ahí afuera
            esperándote.
          </div>
        </div>

        {/* PROFIT MAXIMIZER UPSELL */}
        <ProfitMaximizerUpsell data-id="element-2201" />
      </div>

      {/* FOOTER NAV */}
      <div className="mt-5 flex items-center justify-between border-t border-[#1a1a1a] bg-black px-4 py-6 md:px-10" data-id="element-2202">
        <a href="/modulo-3" className="flex items-center gap-1.5 text-[12px] font-bold text-[#555] transition-colors hover:text-white" data-id="element-2203">
          ← Módulo 3
        </a>
        <div className="font-heading text-[11px] font-black tracking-[3px] text-[#333] uppercase" data-id="element-2204">
          AI <span className="text-[#F5C842]" data-id="element-2205">WEB CLOSER</span>
        </div>
        <div className="rounded bg-[#4caf50] px-7 py-3 font-heading text-[12px] font-black tracking-[1px] text-black uppercase" data-id="element-2206">
          ✓ Curso Completado
        </div>
      </div>
    </div>;
}